import React from 'react'

const HomeBody = () => {
    return (
        <div>
            <div style={{ marginTop: "50px", marginBottom: "50px" }} className="container">
                <div className="row">
                    <div style={{ textAlign: "center" }} className="col-md-12 col-sm-12 col-lg-12">
                        <h1>About Eureka</h1>
                        <hr style={{ width: "25%", backgroundColor: "green", height: "7px" }} />
                        <p style={{fontSize:"18px"}}>Eureka-the journey from raw thinking & imagination to a properly designed innovation!

                            It began in 2018 as a research competition initiative by Chemical Engineering Society (ChES) , SVNIT where teams with different thought processes, innovations compete with each other on a common platform to solve different problems after performing meticulous research work on their problem statements. Along with research, this initiative aims to promotes a sense of cooperation, coordination & patience among its participants.

                            Team ChES is proud to say that, participants of eureka 1.0 applied the experience gained in eureka to compete in national and international research competitions like <strong>ChemTech Student Outreach Program</strong> and <strong>Smart India Hackathon.</strong></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeBody
